// extracted by mini-css-extract-plugin
export default {"selectorPaper":"ibB9yS_d82EW2GOCOVyd"};